module.exports = __webpack_public_path__ + "images/twitter-c257bd4ec9a594744ef30afcd22c4700.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/social/twitter.jpg
// module id = 14
// module chunks = 0